import { render, staticRenderFns } from "./settlementInfo.vue?vue&type=template&id=9e4ca36a&scoped=true&"
import script from "./settlementInfo.vue?vue&type=script&lang=js&"
export * from "./settlementInfo.vue?vue&type=script&lang=js&"
import style0 from "./settlementInfo.vue?vue&type=style&index=0&id=9e4ca36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4ca36a",
  null
  
)

export default component.exports